export { default } from "./CurricVisualiserFiltersDesktop";
export * from "./CurricVisualiserFiltersDesktop";
